let footerTopData = [
    {id: 1, title: "BOUNCER", text: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever.Since the 1500s, when an unknown printer." },
    {id: 2, title: "Follow Us", text: "Since the 1500s, when an unknown printer took a galley of type and scrambled." },
    {id: 3, title: "Contact Us", text: "My Company , 4578 Marmora Road, Glasgow D04 89GR Call us now: 0123-456-789 Email: support@whatever.com" },
]

export default footerTopData